const EXTENSIONS: Record<string, string> = {
  "audio/webm": "webm",
  "audio/ogg": "ogg",
  "audio/mp4": "m4a",
  "audio/x-m4a": "m4a",
  "audio/aac": "aac",
  "audio/mpeg": "mp3",
  "audio/wav": "wav",
  "audio/x-wav": "wav",
  "video/webm": "webm",
  "video/mp4": "mp4",
};

const pad = (value: number): string => String(value).padStart(2, "0");

export const audioDownloadName = (blob: Blob, at = new Date()): string => {
  const type = blob.type.split(";")[0]?.trim().toLowerCase() ?? "";
  const extension = EXTENSIONS[type] ?? "webm";
  const stamp = `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}-${pad(at.getHours())}${pad(at.getMinutes())}`;
  return `rosc-recording-${stamp}.${extension}`;
};

/**
 * Saves audio that has not reached the server to the user's device, so a
 * failed or stuck submission never leaves the recording only in this tab.
 */
export const downloadAudio = async (
  source: Blob | string,
  fileName?: string,
): Promise<void> => {
  const blob =
    typeof source === "string" ? await (await fetch(source)).blob() : source;
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName ?? audioDownloadName(blob);
    link.rel = "noopener";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    // Give the browser time to start the download before releasing the blob.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
};
